import type * as fromRouter from '@ngrx/router-store';
import type { NmoBaseRouterStoreState } from './';

export const ROUTER_FEATURE_KEY = 'router';

export interface RouterPartialState {
  readonly [ROUTER_FEATURE_KEY]: fromRouter.RouterReducerState<NmoBaseRouterStoreState>;
}
